export const api_domain = process.env.API_URL
export const app_env = process.env.APP_ENV
export const mercure_url = process.env.MERCURE_URL
export const mercure_token = process.env.MERCURE_SUBSCRIBER_TOKEN
export const default_token = process.env.DEFAULT_TOKEN
export const is_dev = process.env.IS_DEV
export const stripe_public_key = process.env.STRIPE_PUBLIC_KEY
export const home_page_url = process.env.HOME_PAGE_URL
export const account_url = process.env.ACCOUNT_URL
export const claptech_url = process.env.CLAPTECH_URL
export const tv_url = process.env.TV_URL
export const minio_url = process.env.MINIO_URL
export const google_client_id = process.env.GOOGLE_CLIENT_ID
export const simple_user_role = 'default-roles-claptech'
export const admin_user_role = 'admin-role-claptech'
